import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';

import { Icon } from 'coreOld/elements';

import { HandleWrapper, iconStyle } from './dragHandleStyle';

interface IProps {
  attributes: DraggableAttributes;
  listeners: SyntheticListenerMap;
  isGrabbing?: boolean;
}

const DragHandleView = ({ attributes, listeners, isGrabbing }: IProps) => {
  return (
    <HandleWrapper {...attributes} {...listeners}>
      <Icon name={Icon.ELLIPSIS_VERTICAL} style={iconStyle(isGrabbing)} />
    </HandleWrapper>
  );
};

export default DragHandleView;
